import { Accents, Component, Knobs, Story } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  heading: {
    default: 'heading',
    editor: 'textbox',
  },
  subHeading: {
    default: 'subhead',
    editor: 'textbox',
  },
  accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
};

const PlaygroundKnobsV3: Knobs = {
  ...PlaygroundKnobs,
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const KPIStory: Story = {
  title: 'KPI card',
  description: 'A simple KPI card',
  coreComponent: {
    html: `<tag-card version='2' accent='navy' background-image='access'>
      <tag-app-header icon='LineChartSolid2' heading='Sales Order Processing KPIs' heading-accent='white'></tag-app-header>
      <tag-stats{{...knobs}}>
        <tag-stats-data value="21" label="Outstanding Orders"></tag-stats-data>
        <tag-stats-data value="£66,040.98" label="Order Value"></tag-stats-data>
      </tag-stats>
    </tag-card>`,
    knobs: PlaygroundKnobs,
  },
  coreComponent_v3: {
    html: `
    <tag3-card accent='navy' background-image='access'>
    <tag3-app-header icon-accent='navy' icon='LineChartSolid2' heading='Sales Order Processing KPIs' heading-accent='white'></tag3-app-header>
      <tag3-stats{{...knobs}}>
        <tag3-stats-data label="Outstanding Orders" value="21"></tag3-stats-data>
        <tag3-stats-data label="Order Value" value="£66,040.98"></tag3-stats-data>
      </tag3-stats>
    </tag3-card>
    `,
    knobs: PlaygroundKnobsV3,
  },
  reactWrapper: {
    jsx: `<TagCard version='2' accent='navy' backgroundImage='access'>
      <TagAppHeader icon='LineChartSolid2' heading='Sales Order Processing KPIs' headingAccent='white' />
      <TagStats
        data={[
          { label: 'Outstanding Orders', value: '21' },
          { label: 'Order Value', value: '£66,040.98' },
        ]}
        labelField="label"
        valueField="value"
        {{...knobs}}
      />
    </TagCard>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Card accent='navy' backgroundImage='access'>
      <Tag3AppHeader icon='LineChartSolid2' iconAccent='navy' heading='Sales Order Processing KPIs' headingAccent='white' />
      <Tag3Stats{{...knobs}}>
        <Tag3StatsData label="Outstanding Orders" value="21"></Tag3StatsData>
        <Tag3StatsData label="Order Value" value="£66,040.98"></Tag3StatsData>
      </Tag3Stats>
    </Tag3Card>`,
    knobs: PlaygroundKnobsV3,
  },
};

const DataStory: Story = {
  title: 'Data',
  description: 'A simple KPI card with stats send by data',
  coreComponent: {
    html: `<tag-card version='2' accent='navy' background-image='access'>
      <tag-app-header icon='LineChartSolid2' heading='Sales Order Processing KPIs' heading-accent='white'></tag-app-header>
      <tag-stats{{...knobs}} value-field="val" label-field="lab"></tag-stats>
    </tag-card>`,
    js: `
    var stats = document.querySelector('tag-stats');
    stats.data = [{
      val: "21",
      lab: "Outstanding Orders"
    },
    {
      val: "£66,040.98",
      lab: "Order Value"
    }];
    `,
    knobs: PlaygroundKnobs,
  },
  coreComponent_v3: {
    html: `
    <tag3-card accent='navy' background-image='access'>
    <tag3-app-header icon='LineChartSolid2' heading='Sales Order Processing KPIs' heading-accent='white'></tag3-app-header>
      <tag3-stats{{...knobs}} value-field="val" label-field="lab"></tag3-stats>
    </tag3-card>
    `,
    js: `
    var stats = document.querySelector('tag3-stats');
    stats.data = [{
      val: "21",
      lab: "Outstanding Orders"
    },
    {
      val: "£66,040.98",
      lab: "Order Value"
    }];
    `,
    knobs: PlaygroundKnobsV3,
  },
  reactWrapper: {
    jsx: `<TagCard version='2' accent='navy' backgroundImage='access'>
      <TagAppHeader icon='LineChartSolid2' heading='Sales Order Processing KPIs' headingAccent='white' />
      <TagStats
        data={[
          { label: 'Outstanding Orders', value: '21' },
          { label: 'Order Value', value: '£66,040.98' },
        ]}
        labelField="label"
        valueField="value"
        {{...knobs}}
      />
    </TagCard>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Card accent='navy' backgroundImage='access'>
      <Tag3AppHeader icon='LineChartSolid2' iconAccent='navy' heading='Sales Order Processing KPIs' headingAccent='white' />
      <Tag3Stats
        data={[
          { label: 'Outstanding Orders', value: '21' },
          { label: 'Order Value', value: '£66,040.98' },
        ]}
        labelField="label"
        valueField="value"
        {{...knobs}}/>
    </Tag3Card>`,
    knobs: PlaygroundKnobsV3,
  },
};

const SlotsStory: Story = {
  title: 'Slots',
  description: 'A KPI card that makes use of the header and content slots',
  coreComponent: {
    html: `<tag-card version='2' accent='keppel' background-image='access'>
  <tag-app-header icon='BarChart' heading='Topline Sales Overview' heading-accent='white'></tag-app-header>
    <tag-stats accent='white'>
      <div slot="content" style="display:flex; width:100%;">
        <div style="width: 50%;">
          <tag-text type="kpi" accent="white" text="£12,056"></tag-text>
          <tag-text type="kpi-label" accent="white" text="Today" text-style='{"font-weight": "bold"}'></tag-text>
          <tag-text type="kpi-label" accent="white" text="24/10/2019" text-style='{"font-size": "16px"}'></tag-text>
        </div>
        <div style="width: 50%;">
          <tag-text type="kpi" accent="white" text="-14.2%"></tag-text>
          <tag-text type="kpi-label" accent="white" text="Last Year"></tag-text>
        </div>
      </div>
      <div slot="header" style="display:flex;">
        <tag-text accent="white" text="1:43:52 PM" text-style='{"font-weight": "bold"}'></tag-text>
        <button style="background-color: transparent; border: 0;">
          <tag-icon icon="Refresh" accent="white"></tag-icon>
        </button>
      </div>
  </tag-stats>
</tag-card>`,
  },
  coreComponent_v3: {
    html: `<tag3-card accent='keppel' background-image='access'>
  <tag3-app-header icon='BarChart' icon-accent='keppel' heading='Topline Sales Overview' heading-accent='white'></tag3-app-header>
    <tag3-stats accent='white'>
      <div slot="content" style="display:flex; width:100%;">
        <div style="width: 50%;">
          <tag3-text type="kpi" accent="white" text="£12,056"></tag3-text>
          <tag3-text type="kpi-label" accent="white" text="Today" text-style='{"font-weight": "bold"}'></tag3-text>
          <tag3-text type="kpi-label" accent="white" text="24/10/2019" text-style='{"font-size": "16px"}'></tag3-text>
        </div>
        <div style="width: 50%;">
          <tag3-text type="kpi" accent="white" text="-14.2%"></tag3-text>
          <tag3-text type="kpi-label" accent="white" text="Last Year"></tag3-text>
        </div>
      </div>
      <div slot="header" style="display:flex; align-items: center;">
        <tag3-text accent="white" text="1:43:52 PM" text-style='{"font-weight": "bold"}'></tag3-text>
        <button style="background-color: transparent; border: 0;">
          <tag3-icon icon="Refresh" accent="white"></tag3-icon>
        </button>
      </div>
  </tag3-stats>
</tag3-card>`,
  },
  reactWrapper: {
    jsx: `<TagCard version='2' accent='keppel' backgroundImage='access'>
  <TagAppHeader icon='BarChart' heading='Topline Sales Overview' headingAccent='white' />
    <TagStats accent='white'>
      <div slot="content" style={{display:"flex", width:"100%"}}>
        <div style={{width: "50%"}}>
          <TagText type="kpi" accent="white" text="£12,056" />
          <TagText type="kpi-label" accent="white" text="Today" textStyle={{fontWeight: "bold"}} />
          <TagText type="kpi-label" accent="white" text="24/10/2019" textStyle={{fontSize: "16px"}} />
        </div>
        <div style={{width: "50%"}}>
          <TagText type="kpi" accent="white" text="-14.2%" />
          <TagText type="kpi-label" accent="white" text="Last Year" />
        </div>
      </div>
      <div slot="header" style={{display:"flex"}}>
        <TagText accent="white" text="1:43:52 PM" textStyle={{fontWeight: "bold"}} />
        <button style={{backgroundColor: "transparent", border: "0"}}>
          <TagIcon icon="Refresh" accent="white" />
        </button>
      </div>
  </TagStats>
</TagCard>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Card accent='keppel' backgroundImage='access'>
    <Tag3AppHeader icon='BarChart' iconAccent='keppel' heading='Topline Sales Overview' headingAccent='white' />
      <Tag3Stats accent='white'>
        <div slot="content" style={{display:"flex", width:"100%"}}>
          <div style={{width: "50%"}}>
            <TagText type="kpi" accent="white" text="£12,056" />
            <TagText type="kpi-label" accent="white" text="Today" textStyle={{fontWeight: "bold"}} />
            <TagText type="kpi-label" accent="white" text="24/10/2019" textStyle={{fontSize: "16px"}} />
          </div>
          <div style={{width: "50%"}}>
            <TagText type="kpi" accent="white" text="-14.2%" />
            <TagText type="kpi-label" accent="white" text="Last Year" />
          </div>
        </div>
        <div slot="header" style={{display:"flex"}}>
          <TagText accent="white" text="1:43:52 PM" textStyle={{fontWeight: "bold"}} />
          <button style={{backgroundColor: "transparent", border: "0"}}>
            <TagIcon icon="Refresh" accent="white" />
          </button>
        </div>
    </Tag3Stats>
  </Tag3Card>`,
  },
};

const CarouselStory: Story = {
  title: 'Carousel',
  description: 'A KPI card with the stats in a carousel',
  coreComponent: {
    html: `<tag-card version='2' accent='access' background-image='access'>
    <tag-app-header icon='BarChart2' heading='KPIs' heading-accent='white'></tag-app-header>
    <div style="padding: 10px 0px;">
      <tag-carousel dots-accent='access'>
          <tag-carousel-slide>
            <tag-stats>
              <tag-stats-data value="21" label="Outstanding Orders"></tag-stats-data>
              <tag-stats-data value="£66,040.98" label="Order Value"></tag-stats-data>
            </tag-stats>
          </tag-carousel-slide>
          <tag-carousel-slide>
          <tag-stats>
            <tag-stats-data value="10" label="Outstanding Calls"></tag-stats-data>
            <tag-stats-data value="2.3 hrs" label="Average Wait"></tag-stats-data>
          </tag-stats>
          </tag-carousel-slide>
          <tag-carousel-slide>
          <tag-stats>
            <tag-stats-data value="4" label="Leads"></tag-stats-data>
            <tag-stats-data value="£14.7K" label="Lead Value"></tag-stats-data>
          </tag-stats>
          </tag-carousel-slide>
      </tag-carousel>
    </div>
  </tag-card>`,
  },
  coreComponent_v3: {
    html: `<tag3-card accent='access' background-image='access'>
    <tag3-app-header icon='BarChart2' icon-accent='access' heading='KPIs' heading-accent='white'></tag3-app-header>
    <div style="padding: 10px 0px;">
      <tag3-carousel dots-accent='access'>
          <tag3-carousel-slide>
            <tag3-stats>
              <tag3-stats-data value="21" label="Outstanding Orders"></tag3-stats-data>
              <tag3-stats-data value="£66,040.98" label="Order Value"></tag3-stats-data>
            </tag3-stats>
          </tag3-carousel-slide>
          <tag3-carousel-slide>
          <tag3-stats>
            <tag3-stats-data value="10" label="Outstanding Calls"></tag3-stats-data>
            <tag3-stats-data value="2.3 hrs" label="Average Wait"></tag3-stats-data>
          </tag3-stats>
          </tag3-carousel-slide>
          <tag3-carousel-slide>
          <tag3-stats>
            <tag3-stats-data value="4" label="Leads"></tag3-stats-data>
            <tag3-stats-data value="£14.7K" label="Lead Value"></tag3-stats-data>
          </tag3-stats>
          </tag3-carousel-slide>
      </tag3-carousel>
    </div>
  </tag3-card>`,
  },
  reactWrapper: {
    jsx: `<TagCard version='2' accent='access' backgroundImage='access'>
  <TagAppHeader icon='BarChart2' heading='KPIs' headingAccent='white' />
  <div style={{padding: '10px 0px'}}>
    <TagCarousel dotsAccent='access'>
      <TagCarouselSlide>
        <TagStats
          data={[
            { label: 'Outstanding Orders', value: '21' },
            { label: 'Order Value', value: '£66,040.98' },
          ]}
          labelField="label"
          valueField="value"
        />
      </TagCarouselSlide>
      <TagCarouselSlide>
        <TagStats
          data={[
            { label: 'Outstanding Calls', value: '10' },
            { label: 'Average Wait', value: '2.3 hrs' },
          ]}
          labelField="label"
          valueField="value"
        />
      </TagCarouselSlide>
      <TagCarouselSlide>
        <TagStats
          data={[
            { label: 'Leads', value: '4' },
            { label: 'Lead Value', value: '£14.7K' },
          ]}
          labelField="label"
          valueField="value"
        />
      </TagCarouselSlide>
    </TagCarousel>
  </div>
</TagCard>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Card version='2' accent='access' backgroundImage='access'>
  <Tag3AppHeader icon='BarChart2' icon-accent='access' heading='KPIs' headingAccent='white' />
  <div style={{padding: '10px 0px'}}>
    <Tag3Carousel dotsAccent='access'>
      <Tag3CarouselSlide>
        <Tag3Stats
          data={[
            { label: 'Outstanding Orders', value: '21' },
            { label: 'Order Value', value: '£66,040.98' },
          ]}
          labelField="label"
          valueField="value"
        />
      </Tag3CarouselSlide>
      <Tag3CarouselSlide>
        <Tag3Stats
          data={[
            { label: 'Outstanding Calls', value: '10' },
            { label: 'Average Wait', value: '2.3 hrs' },
          ]}
          labelField="label"
          valueField="value"
        />
      </Tag3CarouselSlide>
      <Tag3CarouselSlide>
        <Tag3Stats
          data={[
            { label: 'Leads', value: '4' },
            { label: 'Lead Value', value: '£14.7K' },
          ]}
          labelField="label"
          valueField="value"
        />
      </Tag3CarouselSlide>
    </Tag3Carousel>
  </div>
</Tag3Card>`,
  },
};

export const TagStatsDataDocs: Component = {
  type: 'component',
  name: 'stats-data',
  description: 'Provides stats data to tag-stats',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'label',
      description: 'The label for the stat',
      type: 'string',
    },
    {
      name: 'value',
      description: 'The value of the stat',
      type: 'string',
    },
    {
      name: 'accent',
      default: 'dolphinblue',
      description: 'V3 Only: The text colour',
      type: 'string',
    },
    {
      name: 'colourScheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [],
};

export const TagStatsDocs: Component = {
  type: 'component',
  name: 'stats',
  description: 'Renders a collection of stats',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'heading',
      description: 'The heading for the stats',
      type: 'string',
    },
    {
      name: 'subHeading',
      description: 'The sub heading for the stats',
      type: 'string',
    },
    {
      name: 'accent',
      default: 'dolphinblue',
      description: 'The text colour',
      type: 'string',
    },
    {
      name: 'data',
      description: 'An array containing the stat names and values',
      type: 'any[]',
    },
    {
      name: 'labelField',
      description: 'The field from the data array that gives the label',
      type: 'string',
    },
    {
      name: 'valueField',
      description: 'The field from the data array that gives the value',
      type: 'string',
    },
    {
      name: 'colourScheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [KPIStory, DataStory, CarouselStory, SlotsStory],
  childComponents: [TagStatsDataDocs],
};
